import { useReduxState } from 'hooks';
import { Icon } from 'components/common/icons';

import type { IconProp } from 'components/common/icons/Icon';

export type InfoCountTileContentProps = {
  category?: 'default' | 'warning';
  icon: IconProp;
  text: string;
  value: number;
};

const InfoCountTileContent = ({
  category = 'default',
  icon,
  text,
  value
}: InfoCountTileContentProps) => {
  const { theme } = useReduxState();

  return (
    <div className={`content content-${category}`}>
      <div className="inner">
        <div className="count">{value}</div>
        <div className="text">{text}</div>
      </div>

      <div className="icon">
        <Icon icon={icon} />
      </div>

      <style jsx>{`
        .content {
          align-items: center;
          color: ${theme.textColor};
          display: flex;
          gap: 10px;
        }
        .inner {
          align-items: center;
          display: flex;
          flex-grow: 1;
          gap: 15px;
        }
        .count {
          color: ${theme.textColorLight};
          font-size: 3.6rem;
          font-weight: 700;
        }
        .text {
          color: ${theme.textColorLight};
          font-size: 1.4rem;
          font-weight: 600;
          line-height: 1.2;
          max-width: 120px;
          text-align: left;
          word-break: break-word;
        }
        .icon {
          align-items: center;
          background-color: ${theme.lightGrey};
          border-radius: 40px;
          color: ${theme.textColorLight};
          display: flex;
          flex-shrink: 0;
          font-size: 1.5rem;
          justify-content: center;
          height: 40px;
          width: 40px;
        }
        .content-warning .icon {
          background-color: ${theme.warningLightColor};
          color: ${theme.warningLightTextColor};
        }
      `}</style>
    </div>
  );
};

export default InfoCountTileContent;
